import { GzRmTopResourcesRiskWidgetWebComponent } from './component/GzRmTopResourcesRiskWidgetWebComponent';

export { GzRmTopResourcesRiskWidgetWebComponent };
